import React from 'react';
import {connect} from 'react-redux';
import Loader from '../Presentation/Loader';
import Page from '../Containers/Page';
import {confirmEmaildAction} from '../../actions/Auth';
import {browserHistory} from 'react-router'
import {openSuccessPopup, openFailPopup} from '../../actions/Popup';

class ConfirmEmail extends React.Component {

    componentDidMount() {
        this.dispatchConfirmEmail();
    }

    dispatchConfirmEmail() {
        const {token} = this.props.routeParams;
        this.props.dispatch(confirmEmaildAction(this.dispatchConfirmEmail, token))
            .then(() => {
                this.props.dispatch(openSuccessPopup({
                    title: "Честито",
                    text: "Успешно валидирахме твоя имейл."
                }));

                browserHistory.push('/login');
            })
            .catch(() => {
                this.props.dispatch(openFailPopup({
                    title: "Грешка",
                    text: "Възникна грешка по време на валидирането на твоя имейл."
                }));

                browserHistory.push('/login');
            });
    }

    render() {
        return <Page title="Активиране на акаунт">
            <Loader show={true}/>
        </Page>
    }
}

const mapStateToProps = (state) => {
    return {
        confirmEmailPending: state.auth.confirmEmailPending
    }
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ConfirmEmail);


// WEBPACK FOOTER //
// ./src/components/Pages/ConfirmEmail.js